import React, { Component } from 'react';
import UsuariosRegistrados from './UsuariosRegistrados';
import ViajesUsuarios from './ViajesUsuarios';
import ViajesConductor from './ViajesConductor';
import GananciaSocio from './GanaciaSocio';
import ReporteTemplate from './ReporteTemplate';
import ReporteConductores from './ReporteConductores';
import ReporteVehiculos from './ReporteVehiculos';
import SociosGanancias from './SociosGanancias';
import ViajesEmpresas from '../ViajesEmpresas/ViajesEmpresas';
import Calicacion from './ReporteCalificacionGlobal';
import CalicacionViaje from './ReporteCalificaciones';
import store from '../../store';
import copyright from '../../img/copyright-gray.png';

class Reportes extends Component {
	constructor(props) {
		super(props);
		this.state = {
			reporte: 'Reporte de conductores'
		}

		this.handleChange = this.handleChange.bind(this);
		this.renderContent = this.renderContent.bind(this);
		this.ocultarMenu = this.ocultarMenu.bind(this);

	}

	handleChange() {
		let combo = this.combo.value;
		this.setState({
			reporte: combo
		})
	}

	renderContent() {
		if (this.state.reporte === 'Reporte de conductores') {
			return <ReporteConductores />
		}
		else if (this.state.reporte === 'Reporte de vehiculos') {
			return <ReporteVehiculos />
		}
		else if (this.state.reporte === 'Viajes por empresas') {
			return <ViajesEmpresas />
		}
	}

	ocultarMenu() {
		store.dispatch({
			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	render() {

		return (

			<div className="Reportes container" onClick={this.ocultarMenu}>
				<div className="form-group row ">
					<div className="col-md-3">
						<select className="form-control" ref={input => { this.combo = input; }} onChange={this.handleChange}>
							<option>Reporte de conductores</option>
							<option>Reporte de vehiculos</option>
							<option>Viajes por empresas</option>
							{/*<option>Reporte de calificacion x viaje</option>*/}
						</select>
					</div>
				</div>

				{this.renderContent()}

				<footer class="footer-pg mt-auto py-3" style={{ width: '100%' }}>
					<div class="container">
						<div class="row">
							<div className="col-md-4 col-sm-4">
							</div>
							<div class="col-sm">
								<img src={copyright} />
							</div>
						</div>
					</div>
				</footer>
			</div>
		)
	}
}
export default Reportes;


// WEBPACK FOOTER //
// ./src/Components/Reportes/Reportes.jsx